import { render, staticRenderFns } from "./SidebarInfo.vue?vue&type=template&id=5c961dc3&scoped=true&"
import script from "./SidebarInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarInfo.vue?vue&type=script&lang=js&"
import style0 from "./SidebarInfo.vue?vue&type=style&index=0&id=5c961dc3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c961dc3",
  null
  
)

export default component.exports